module.exports = __webpack_public_path__ + "static/media/card.afa87b13.svg";